import { useSelector } from "react-redux";

import { Box, Button, Grid, Link, Typography } from "@mui/material";
import { lightBlue } from "@mui/material/colors";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

import Tags from "../Tags";

const DatasetsData = ({ subheaderStyle, useMobileLayout }) => {
  const selectedRow = useSelector((state) => state.dataExplorer.selectedRow);

  return (
    <>
      <Grid
        item
        xs={12}
        md={useMobileLayout ? 12 : 8}
        sx={{ flexGrow: 1, overflowY: "auto" }}
      >
        <Box sx={{ width: "100%" }}>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Typography {...subheaderStyle}>
              Source: {selectedRow.row.source}
            </Typography>
          </Box>
          <Typography {...subheaderStyle}>About</Typography>
          <Typography
            sx={{
              color: "primary.contrastText",
            }}
          >
            {selectedRow.row.description}
          </Typography>
          <Typography {...subheaderStyle}>Tags</Typography>
          <Tags selectedRow={selectedRow} />

          <Box>
            <Typography {...subheaderStyle}>Contacts</Typography>
            <Box>
              <Typography sx={{ color: "primary.contrastText" }}>
                {selectedRow.row.contact_name}
              </Typography>
              <Link
                href={`mailto:${selectedRow.row.contact_email}`}
                sx={{
                  color: "#039be5",
                  display: "block",
                }}
              >
                {selectedRow.row.contact_email}
              </Link>
            </Box>
            {selectedRow.row.creator_name ? (
              <Box>
                <Typography sx={{ color: "primary.contrastText" }}>
                  {selectedRow.row.creator_name} (Creator)
                </Typography>
                <Link
                  href={`mailto:${selectedRow.row.creator_email}`}
                  sx={{
                    color: "#039be5",
                    display: "block",
                  }}
                >
                  {selectedRow.row.creator_email}
                </Link>
              </Box>
            ) : null}
          </Box>
        </Box>
      </Grid>
      <Grid item xs={useMobileLayout ? 12 : 4} sx={{ mt: 3 }}>
        <Button
          fullWidth
          variant="contained"
          startIcon={<OpenInNewIcon />}
          href={selectedRow.row.data_access_url}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            backgroundColor: "background.main",
            color: "secondary.contrastText",
            minWidth: "200px",
            boxShadow: "none",
            "&:hover": {
              backgroundColor: lightBlue[700],
            },
          }}
        >
          Access Dataset
        </Button>
      </Grid>
    </>
  );
};

export default DatasetsData;
